import React, { useState } from 'react';
import { Container, TextField, Button, Grid, Box, Typography } from '@mui/material';
import { ForgotPassword as ForgotPasswordAPI, ResetPassword } from '../../../api';
import { useParams, useNavigate } from "react-router-dom";
import { validate } from 'validate.js';
import constraints from '../validate-email-constraints';

const ForgotPassword = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordInvalid, setConfirmPasswordInvalid] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [success, setSuccess] = useState()

  const params = useParams();
  const navigate = useNavigate();
  const { uid, hash } = params

  const handleSubmit = async e => {
    const emailAddress = email.toLowerCase().trim()
    e.preventDefault();
    setSubmitError();

    if (hash) {
      ResetPassword({uid, password, hash}).then(()=>navigate('/')).catch(e => {
        const error = (e.response && e.response.data && e.response.data.errors) || e.message
        setSubmitError(error);
      })
    }
    else {
      const validation = validate({emailAddress}, constraints)

      if (validation)
        setSubmitError(validation.emailAddress)
      else
        ForgotPasswordAPI(emailAddress).then(() => setSuccess(true)).catch(e => {
          const error = (e.response && e.response.data && e.response.data.errors) || e.message
          setSubmitError(error);
        })
    }
  }

  const validateConfirmPassword = e => {
    setConfirmPassword(e.target.value)
    setConfirmPasswordInvalid(password !== e.target.value)
  }

  if (success)
    return (<Typography>A password reset link was sent to the email address.</Typography>)

  return (
    <Container>
      <Typography component="h1" variant="h4">Forgot Password</Typography>
      {submitError ? <Typography component="p" color="error">{submitError}</Typography> : null}
      <form onSubmit={handleSubmit}>
        {(hash && (
          <>
            <TextField sx={{marginTop: 1}} value={password} name="password" type="password" fullWidth={true} required={true} label="Password" id="password" autoComplete="false" onChange={e => setPassword(e.target.value)} />
            <TextField sx={{marginTop: 1}} value={confirmPassword} name="confirmPassword" type="password" fullWidth={true} error={confirmPasswordInvalid} required={true} label="Confirm Password" id="confirmPassword" autoComplete="false" onChange={validateConfirmPassword} />
          </>
        )) || (
          <TextField sx={{marginTop: 1}} value={email} name="email" fullWidth={true} required={true} label="Email address" id="email" onChange={e => setEmail(e.target.value)} />
        )}
        <Grid container justifyContent="center">
          <Box mt={5} mb={5}>
            <Button variant="contained" color="primary" type="submit">Submit</Button>
          </Box>
        </Grid>
      </form>
    </Container>
  )
}

export default ForgotPassword;
